import { render } from "./MobileControl.vue?vue&type=template&id=e22f213c"
import script from "./MobileControl.vue?vue&type=script&lang=js"
export * from "./MobileControl.vue?vue&type=script&lang=js"

import "./MobileControl.vue?vue&type=style&index=0&id=e22f213c&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__